<template>
  <div class="container"> 

    <v-sheet class="pane pa-12">
      <Wizard
        icon  = "mdi-close-octagon-outline"
        color = "error"
      >
        <div class="text-h5 text-center">
          You are not authorized to access this page.
        </div>
      </Wizard>
    </v-sheet>

  </div>
</template>

<script>

// #region Imports

/* Telestream */
import Wizard from '../components/panes/components/Wizard.vue';

// #endregion Imports

export default {

  // #region Properties

  components: {
    Wizard
  }

  // #endregion Properties

}

</script>

<style scoped>

.container {
  width:          100%;
  height:         100%;

  display:        flex;
  flex-direction: row;
  align-items:    center;
  justify-content:center;
}

.pane {
  border-radius:  2px;
  max-width:      400px;
}

</style>
